// FETCH ALL PROPERTIES FROM COMPACTING_INWARD DETAILS
export const FETCH_COMPACTING_INWARD_DETAILS_REQUEST = 'FETCH_COMPACTING_INWARD_DETAILS_REQUEST';
export const FETCH_COMPACTING_INWARD_DETAILS_SUCCESS = 'FETCH_COMPACTING_INWARD_DETAILS_SUCCESS';
export const FETCH_COMPACTING_INWARD_DETAILS_FAILURE = 'FETCH_COMPACTING_INWARD_DETAILS_FAILURE';

// FETCH ALL PROPERTIES FROM COMPACTING_INWARD DETAILS BY ID
export const FETCH_COMPACTING_INWARD_DETAILS_BY_ID_REQUEST = 'FETCH_COMPACTING_INWARD_DETAILS_BY_ID_REQUEST';
export const FETCH_COMPACTING_INWARD_DETAILS_BY_ID_SUCCESS = 'FETCH_COMPACTING_INWARD_DETAILS_BY_ID_SUCCESS';
export const FETCH_COMPACTING_INWARD_DETAILS_BY_ID_FAILURE = 'FETCH_COMPACTING_INWARD_DETAILS_BY_ID_FAILURE';

// CREATE PROPERTIES FOR COMPACTING_INWARD DETAILS
export const CREATE_COMPACTING_INWARD_DETAILS_REQUEST = 'CREATE_COMPACTING_INWARD_DETAILS_REQUEST';
export const CREATE_COMPACTING_INWARD_DETAILS_SUCCESS = 'CREATE_COMPACTING_INWARD_DETAILS_SUCCESS';
export const CREATE_COMPACTING_INWARD_DETAILS_FAILURE = 'CREATE_COMPACTING_INWARD_DETAILS_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_COMPACTING_INWARD_DETAILS = 'CREATE_USER_FORM_COMPACTING_INWARD_DETAILS';

// UPDATE PROPERTIES FOR COMPACTING_INWARD DETAILS
export const UPDATE_COMPACTING_INWARD_DETAILS_REQUEST = 'UPDATE_COMPACTING_INWARD_DETAILS_REQUEST';
export const UPDATE_COMPACTING_INWARD_DETAILS_SUCCESS = 'UPDATE_COMPACTING_INWARD_DETAILS_SUCCESS';
export const UPDATE_COMPACTING_INWARD_DETAILS_FAILURE = 'UPDATE_COMPACTING_INWARD_DETAILS_FAILURE';

// FETCH SINGLE COMPACTING_INWARD_DETAILS
export const FETCH_SINGLE_COMPACTING_INWARD_DETAILS_REQUEST = 'FETCH_SINGLE_COMPACTING_INWARD_DETAILS_REQUEST';
export const FETCH_SINGLE_COMPACTING_INWARD_DETAILS_SUCCESS = 'FETCH_SINGLE_COMPACTING_INWARD_DETAILS_SUCCESS';
export const FETCH_SINGLE_COMPACTING_INWARD_DETAILS_FAILURE = 'FETCH_SINGLE_COMPACTING_INWARD_DETAILS_FAILURE';

// DELETE PROPERTIES FOR COMPACTING_INWARD DETAILS
export const DELETE_COMPACTING_INWARD_DETAILS_REQUEST = 'DELETE_COMPACTING_INWARD_DETAILS_REQUEST';
export const DELETE_COMPACTING_INWARD_DETAILS_SUCCESS = 'DELETE_COMPACTING_INWARD_DETAILS_SUCCESS';
export const DELETE_COMPACTING_INWARD_DETAILS_FAILURE = 'DELETE_COMPACTING_INWARD_DETAILS_FAILURE';

export const FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_REQUEST = 'FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_REQUEST';
export const FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_SUCCESS = 'FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_SUCCESS';
export const FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_FAILURE = 'FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_FAILURE';

// USERFORM RESET

export const COMPACTING_INWARD_DETAILS_USERFORM_RESET = 'COMPACTING_INWARD_DETAILS_USERFORM_RESET';

export const COMPACTING_INWARD_DETAILS_DC_DETAILS_DISABLED = 'COMPACTING_INWARD_DETAILS_DC_DETAILS_DISABLED';
